import type { VenueDetailBlockDto } from '@/services/platform/api/model';

export interface LinkBlock {
  name?: string | null;
  url?: string | null;
  target?: string | null;
}

export interface ImageBlock {
  url?: string | null;
  width?: number | null;
  height?: number | null;
}

export type VenueDetailBlock =
  | {
      type: 'intro';
      title?: string | null;
      titleHeading?: string | null;
      address?: string | null;
      description?: string | null;
      primaryCta?: LinkBlock | null;
      secondaryCta?: LinkBlock | null;
    }
  | {
      type: 'accordion';
      title?: string | null;
      description?: string | null;
    }
  | {
      type: 'openingHours';
      items?: Array<{ day?: string | null; timeInterval?: string | null }> | null;
    }
  | {
      type: 'venueSlider';
      title?: string | null;
      titleHeading?: string | null;
      items?: Array<{
        nodeKey?: string | null;
        image?: ImageBlock | null;
        title?: string | null;
        description?: string | null;
      }> | null;
    }
  | {
      type: 'eventSlider';
      title?: string | null;
      titleHeading?: string | null;
      link?: LinkBlock | null;
    }
  | {
      type: 'shopSlider';
      title?: string | null;
      titleHeading?: string | null;
      link?: LinkBlock | null;
      items?: Array<{
        image?: ImageBlock | null;
        title?: string | null;
        location?: string | null;
        link?: LinkBlock | null;
      }> | null;
    }
  | {
      type: 'roomsSlider';
      title?: string | null;
      titleHeading?: string | null;
      items?: RoomsSliderItemBlock[] | null;
    };

export interface RoomsSliderItemBlock {
  slug?: string | null;
  title?: string | null;
  description?: string | null;
  shortDescription?: string | null;
  image?: ImageBlock | null;
  images?: ImageBlock[] | null;
}

const KNOWN_TYPES = new Set([
  'intro',
  'accordion',
  'openingHours',
  'venueSlider',
  'eventSlider',
  'shopSlider',
  'roomsSlider',
]);

export function asDetailBlock(b: VenueDetailBlockDto): VenueDetailBlock | null {
  const raw = b as Record<string, unknown>;
  if (typeof raw.type !== 'string' || !KNOWN_TYPES.has(raw.type)) return null;
  return raw as unknown as VenueDetailBlock;
}
